import { render, staticRenderFns } from "./UserRoleChangeContainer.vue?vue&type=template&id=002ebb24"
import script from "./UserRoleChangeContainer.js?vue&type=script&lang=js&external"
export * from "./UserRoleChangeContainer.js?vue&type=script&lang=js&external"
import style0 from "./UserRoleChangeContainer.vue?vue&type=style&index=0&id=002ebb24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports